<template>
  <div>
    <b-modal
      ref="modal"
      title="Transferência entre caixas / contas"
      header-class="border-bottom-0"
      size="xs"
      no-close-on-backdrop
    >
      <div class="container-fluid">
        <!-- form  -->

        <div class="row">
          <div class="col-md-12">
            <!-- <select-input
              v-model="form.account_destination.value"
              :options="form.account_destination.options"
              :alias="form.account_destination.alias"
            /> -->
            <account-select-input
              @input="setAccount($event)"
              :exceptId="form.account_id.value"
            />
          </div>
        </div>

        <br />

        <div class="row">
          <div class="col-md-12">
            <div class="form-group">
              <textarea
                alias="Comentários"
                maxlength="500"
                class="form-control"
                id="exampleFormControlTextarea1"
                rows="5"
              ></textarea>
            </div>

            <number-input
              v-model="form.value.value"
              :alias="form.value.alias"
            />
          </div>
        </div>
      </div>

      <br />

      <error-handler :error="error" />

      <b-alert
        :show="alertData.isVisible"
        fade
        variant="danger"
        @dismissed="alertData.isVisible = false"
        dismissible
        >{{ alertData.message }}</b-alert
      >

      <!-- form  -->

      <div slot="modal-footer">
        <button
          role="button"
          class="btn btn-outline-secondary"
          @click="$refs.modal.hide()"
        >
          <i class="fas fa-times"></i> Cancelar
        </button>
        <button
          role="button"
          class="btn btn-success"
          style="margin-left: 5px"
          @click="store"
        >
          <i class="fas fa-check"></i> Salvar
        </button>
      </div>
    </b-modal>
  </div>
</template>

<script>
import Avatar from "vue-avatar";
import Form from "@/mixins/Form.js";
import SeachInput from "../../ui/SearchInput.vue";
import OderPayments from "../../sections/OrderPayments.vue";
import AccountSelectInput from "../inputs/AccountSelectInput.vue";

export default {
  components: {
    Avatar,
    SeachInput,
    OderPayments,
    AccountSelectInput
  },

  data: function () {
    return {
      form: new Form({
        account_destination: {
          alias: "Transferir Para",
          validate: {
            required: true,
          },
          options: {},
        },

        description: {
          default: "TRANSFERÊNCIA",
        },

        history: {},

        value: {
          alias: "Valor",
          validate: {
            required: true,
          },
        },

        //Origin
        account_id: {},
      }),

      error: null,

      alertData: {
        isVisible: false,
        message: null,
      },
    };
  },

  methods: {
    open(account_id) {
      this.reset();

      this.form.account_id.value = account_id;

      this.$refs.modal.show();
    },





    reset() {
      this.alertData.isVisible = false;
      this.error = null;
      this.form.reset();
    },

    async store() {
      this.error = null;

      this.$store.commit("showLoading");

      await this.$store
        .dispatch("accountTransfer/postAccountTransfer", this.form.getValues())
        .then((response) => {
          this.$refs.modal.hide();

          this.$emit("stored");

          this.$store.commit("showAlert", {
            message: "Transferência realizada com sucesso!",
            type: "success",
          });
        })
        .catch((error) => {
          this.error = error;
        });

      this.$store.commit("hideLoading");
    },
    setAccount(account) {
      this.form.account_destination.value = account.id;
    }
  },
};
</script>
